import styled from 'styled-components'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { colors } from '@theme/variables'

export const EventSelectFilterWrapper = styled('button')`
  background: none;
  border: none;
  padding: 0;
`

interface IsConfirmedProps {
  isConfirmed: boolean
}

export const FilterButton = styled(Button)<IsConfirmedProps>(({ isConfirmed }) => ({
  background: colors.white,
  color: isConfirmed ? '#1B8FCB' : colors.bodyText,
  fontWeight: isConfirmed ? 600 : 400,
  minHeight: '28px',
  padding: '2px 0px',
  '&:hover': {
    borderColor: colors.primaryDark,
  },
  '&.Mui-focused': {
    borderColor: colors.primaryDark,
  },
  '.MuiButton-endIcon': {
    marginLeft: '2px',
    fontWeight: isConfirmed ? 600 : 'inherit',
  },
}))

export const FilterExpandIcon = styled(ExpandMoreIcon)<IsConfirmedProps>(props => ({
  color: props.isConfirmed ? '#1B8FCB' : colors.bodyText,
  fontSize: '24px !important',
}))

export const FilterWrapper = styled('div')<IsConfirmedProps>(({ isConfirmed }) => ({
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${isConfirmed ? '#1B8FCB' : colors.lightGrey}`,
  borderRadius: '4px',
  padding: '0px 9px 0px 9px',
  maxWidth: '245px',
}))

export const VerticalDivider = styled(Divider)`
  margin: 0 8px;
  height: 16px;
  align-self: center;
`
